import React, { memo } from 'react';

const Version = () => {
    return <span style={{ float: 'right' }}>Version : v 2025.05.17.00</span>;
};

export default memo(Version);
